/**
 * 일지 공통 갤러리 뷰어 — 발행본 전자작업확인서 뷰어 「시니어 최적화」 반영
 * (스펙: jbbuller_doc issued-viewer-spec.md 확정본)
 *
 * 데이터 모델상 문서(전자작업확인서+작업문서)·현장(작업사진) 모두 이미지 목록이라,
 * 스펙의 시니어 UI 처리(액션바 재배치·탭 개수·확대 토글·사진 프레임·시니어 삭제 등)를
 * 기존 이미지 파이프라인 위에 얹는다. 삭제/관리자/차수/공유 로직은 그대로 유지.
 *
 * · UI 폰트 = 앱 기본(Pretendard), 문서 종이 내부는 렌더 이미지 그대로
 * · 검정 바탕 단일 다크 뷰어 / 옐로우 강조 #FDCF43
 */
import Util from '../../Common/Util';
const G_TOKENS = {
    yellow: '#FDCF43', yellowTx: '#79530C', danger: '#FF382D', frame: '#26262A',
};

export default class Gallery{
    constructor() {
        this.swipe = null;      // $j.Ui.Swipe 컨트롤러
        this._trackKey = null;  // 현재 트랙에 그려둔 (탭 + 사진목록) 키
        this.images = [];
        this.ordernum = null;
        this.img_id = null;
        this.odr = null;
        this.confirmCount = 0;  // 전자작업확인서 총 차수 (5차 경고용)
        this.currentGroup = 'doc'; // 현재 활성 탭 (doc | field)
        this.shareAct = 'share';   // 인라인 선택 오버레이 컨텍스트 (share | save)
        this.shOpen = false;       // 공유/저장 선택 오버레이 열림 여부
    }

    /**
     * 화면초기화, 이벤트핸들러 등록
     * @param ordernum 오더번호
     * @param img_id 이미지 아이디
     */
    init = function(ordernum, img_id = 1) {
        this.ordernum = ordernum;
        this.img_id = img_id;
        this.draw();
        this.initHandler();
    }

    initHandler = function() {
        let self = this;
        let moved = false; // 스와이프/스크롤 후 오는 click 을 확대 토글에서 제외하기 위한 가드

        $('#photoGallDiv')
            .off('.gallery')
            // 상단 액션바
            .on('click.gallery', '.btn-share',    function () { self.onAction('share'); })
            .on('click.gallery', '.btn-download', function () { self.onAction('save'); })
            .on('click.gallery', '.btn-delete',   function () { self.deletePhoto(); })
            .on('click.gallery', '.btn-close',    function () { self.onClose(); })
            // 문서/작업 탭 — 해당 그룹의 첫 사진을 메인으로
            .on('click.gallery', '.gallery-tab', function () {
                const group = $(this).data('tab');
                const first = self.images.find(img => img.group === group);
                first ? self.showPhoto(first.img_id) : self.showEmpty(group);
            })
            // 공유/저장 인라인 선택
            .on('click.gallery', '.g-shscrim', function () { self.closeShare(); })
            .on('click.gallery', '.g-shopt',   function () { self.pickShare($(this).data('withphotos') === 1); })
            // 화면 탭 = 1.35배 확대 토글 (드래그/스크롤이 아닌 순수 탭일 때만)
            .on('touchstart.gallery', '.g-stage', function () { moved = false; })
            .on('touchmove.gallery',  '.g-stage', function () { moved = true; })
            .on('click.gallery', '.b-swipe__card', function () {
                if (moved) { moved = false; return; }
                self.toggleZoom();
            })
            // 시니어 삭제 다이얼로그
            .on('click.gallery', '.g-del-no',  function () { self.closeDelDlg(); })
            .on('click.gallery', '.g-del-yes', function () { self.closeDelDlg(); self._doDeletePhoto(); })
            .on('click.gallery', '.g-del-ov',  function (e) { if (e.target === this) self.closeDelDlg(); });
    }

    draw = function() {
        $('#photoGallDiv')
            .css({
                position: 'fixed', inset: 0, top: 0, left: 0, right: 0, bottom: 0,
                width: '100%', height: '100%', margin: 0, padding: 0,
                border: 'none', 'border-radius': 0, background: '#000',
                display: 'flex', 'flex-direction': 'column',
            })
            .html(this.drawGallery());

        this.getPhoto();
    }

    /**
     * 갤러리 화면 마크업 (스타일은 상단 <style> 블록으로 스코프)
     * @returns {string} html
     */
    drawGallery = function() {
        const t = G_TOKENS;
        const svgShare  = `<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>`;
        const svgSave   = `<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>`;
        const svgTrash  = `<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>`;
        const svgClose  = `<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;

        return `
        <style>
        /* ── 발행본 뷰어 시니어 최적화 (m.css 밖 인라인 스코프) ── */
        #photoGallDiv{ --gy:${t.yellow}; --gytx:${t.yellowTx}; --gdanger:${t.danger}; --gframe:${t.frame}; }
        #photoGallDiv, #photoGallDiv *{ box-sizing:border-box; -webkit-tap-highlight-color:transparent; }

        /* 상단 액션바 */
        #photoGallDiv .g-bar{ position:relative; display:flex; align-items:center; gap:6px; height:64px; padding:0 12px; background:rgba(0,0,0,.6); flex-shrink:0; }
        #photoGallDiv .g-bar .g-sp{ flex:1; }
        #photoGallDiv .g-pill{ height:44px; padding:0 18px; border:none; border-radius:12px; background:var(--gy); color:var(--gytx); font-size:14.5px; font-weight:800; letter-spacing:-.4px; cursor:pointer; text-decoration:none; display:inline-flex; align-items:center; -webkit-appearance:none; appearance:none; }
        #photoGallDiv .g-ic{ display:flex; flex-direction:column; align-items:center; justify-content:center; gap:3px; min-width:44px; min-height:44px; border:none; background:none; color:#fff; font-size:10.5px; font-weight:700; cursor:pointer; -webkit-appearance:none; appearance:none; }
        #photoGallDiv .g-ic svg{ width:22px; height:22px; }
        #photoGallDiv .g-bartitle{ position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); font-size:17px; font-weight:800; letter-spacing:-.3px; color:#fff; display:none; pointer-events:none; }
        /* 오버레이 열림: 닫기·타이틀만 잔류, 나머지 비활성 (오클릭 차단) */
        #photoGallDiv.g-sh-open .g-bar > *:not(.g-shon):not(.g-bartitle){ opacity:0 !important; pointer-events:none; transition:opacity .15s; }
        #photoGallDiv.g-sh-open .g-bartitle{ display:block; }
        #photoGallDiv.g-sh-open .g-shon{ opacity:1; pointer-events:auto; }

        /* 공유/저장 인라인 선택 */
        #photoGallDiv .g-shscrim{ position:absolute; top:64px; left:0; right:0; bottom:0; background:rgba(0,0,0,.5); z-index:11; display:none; }
        #photoGallDiv .g-shscrim.on{ display:block; }
        #photoGallDiv .g-shacc{ position:absolute; top:64px; left:0; right:0; z-index:12; background:#000; overflow:hidden; max-height:0; transition:max-height .25s ease; padding:0 14px; }
        #photoGallDiv .g-shacc.on{ max-height:120px; box-shadow:0 14px 26px rgba(0,0,0,.6); }
        #photoGallDiv .g-shrow{ display:flex; gap:10px; padding:14px 0 18px; }
        #photoGallDiv .g-shopt{ flex:1; height:52px; border-radius:12px; font-size:15px; font-weight:800; letter-spacing:-.3px; cursor:pointer; display:flex; align-items:center; justify-content:center; -webkit-appearance:none; appearance:none; }
        #photoGallDiv .g-shopt.pri{ background:var(--gy); border:none; color:var(--gytx); }
        #photoGallDiv .g-shopt.sec{ background:rgba(255,255,255,.08); border:1.5px solid rgba(255,255,255,.55); color:#fff; }

        /* 탭 */
        #photoGallDiv .g-tabs{ display:flex; gap:8px; padding:8px 14px 8px; background:rgba(0,0,0,.7); flex-shrink:0; }
        /* 크기 고정 (스펙 §3: 76×34, 형태 불변) — width 고정 + 숫자 tabular 로 개수·선택상태 무관 */
        #photoGallDiv .gallery-tab{ width:76px; height:34px; padding:0; border:none; border-radius:999px; flex:0 0 auto; display:inline-flex; align-items:center; justify-content:center; white-space:nowrap; background:rgba(255,255,255,.14); color:rgba(255,255,255,.75); font-size:13.5px; font-weight:800; cursor:pointer; -webkit-appearance:none; appearance:none; }
        #photoGallDiv .gallery-tab.on{ background:#fff; color:#111; }
        #photoGallDiv .gallery-tab .g-cnt{ font-size:13px; font-weight:800; margin-left:5px; letter-spacing:0; font-variant-numeric:tabular-nums; }

        /* 썸네일 바 (2장 이상일 때만, 줄바꿈) */
        #photoGallDiv .g-strip{ display:none; flex-wrap:wrap; gap:8px; padding:0 14px 12px; background:rgba(0,0,0,.7); border-bottom:.5px solid rgba(255,255,255,.08); flex-shrink:0; max-height:140px; overflow-y:auto; }
        #photoGallDiv .g-strip.on{ display:flex; }
        #photoGallDiv .gallery-thumb{ width:52px; height:52px; border-radius:8px; overflow:hidden; border:2px solid rgba(255,255,255,.28); flex-shrink:0; cursor:pointer; background:#2a2a2e; padding:0; }
        #photoGallDiv .gallery-thumb.cur{ border-color:var(--gy); }
        #photoGallDiv .gallery-thumb img{ width:100%; height:100%; object-fit:cover; display:block; }

        /* 콘텐츠 스테이지 */
        #photoGallDiv .g-stage{ position:relative; flex:1; min-height:0; overflow:hidden; background:#0F0F11; }
        #photoGallDiv .b-swipe__track{ display:flex; width:100%; height:100%; transition:transform .3s cubic-bezier(.25,1,.5,1); will-change:transform; }
        #photoGallDiv .b-swipe__card{ flex:0 0 100%; height:100%; display:flex; align-items:center; justify-content:center; padding:10px; }
        /* 문서: 폭 맞춤 + 세로 스크롤(읽기용) */
        #photoGallDiv .g-stage[data-mode="doc"] .b-swipe__card{ align-items:flex-start; overflow-y:auto; -webkit-overflow-scrolling:touch; padding:10px 10px 28px; }
        #photoGallDiv .g-stage[data-mode="doc"] .b-swipe__card img{ width:100%; max-width:560px; height:auto; margin:0 auto; border-radius:4px; background:#fff; }
        /* 작업: 고정 회색 프레임 + contain (사진 방향 무관 레이아웃 불변) */
        #photoGallDiv .g-stage[data-mode="field"] .b-swipe__card{ padding:8px 12px 12px; }
        #photoGallDiv .g-stage[data-mode="field"] .b-swipe__card > span{ width:100%; height:100%; border-radius:8px; background:var(--gframe); display:flex; align-items:center; justify-content:center; overflow:hidden; }
        #photoGallDiv .g-stage[data-mode="field"] .b-swipe__card img{ max-width:100%; max-height:100%; width:auto; height:auto; object-fit:contain; }
        /* 확대 토글 */
        #photoGallDiv .g-stage.zoomed .b-swipe__card img{ transform:scale(1.35); transform-origin:top center; transition:transform .12s; }

        /* 좌우 이동 버튼 */
        #photoGallDiv .b-swipe__prev, #photoGallDiv .b-swipe__next{ position:absolute; top:50%; transform:translateY(-50%); z-index:5; display:flex; align-items:center; justify-content:center; width:46px; height:46px; border:1.5px solid rgba(255,255,255,.35); border-radius:50%; background:rgba(0,0,0,.6); cursor:pointer; -webkit-appearance:none; appearance:none; }
        #photoGallDiv .b-swipe__prev{ left:10px; } #photoGallDiv .b-swipe__next{ right:10px; }
        #photoGallDiv .b-swipe__prev.is-disabled, #photoGallDiv .b-swipe__next.is-disabled{ opacity:.22; pointer-events:none; }

        /* 하단 캡션 칩 (문서/현장 공통) */
        #photoGallDiv .g-caption{ position:absolute; bottom:20px; left:50%; transform:translateX(-50%); z-index:6; background:rgba(0,0,0,.66); color:#fff; font-size:13px; font-weight:800; padding:7px 14px; border-radius:999px; letter-spacing:0; white-space:nowrap; font-variant-numeric:tabular-nums; display:none; }

        /* 빈 상태 */
        #photoGallDiv .gallery-empty{ display:none; position:absolute; inset:0; align-items:center; justify-content:center; font-size:20px; font-weight:600; color:rgba(255,255,255,.55); text-align:center; line-height:1.5; }

        /* 시니어 삭제 다이얼로그 */
        #photoGallDiv .g-del-ov{ position:absolute; inset:0; background:rgba(0,0,0,.55); display:none; align-items:center; justify-content:center; z-index:70; padding:24px; }
        #photoGallDiv .g-del-ov.on{ display:flex; }
        #photoGallDiv .g-del{ background:#fff; color:#121212; border-radius:16px; width:100%; max-width:340px; padding:26px 20px 18px; text-align:center; }
        #photoGallDiv .g-del h4{ font-size:18px; font-weight:800; margin:0 0 9px; }
        #photoGallDiv .g-del p{ font-size:14px; color:#828286; line-height:1.65; margin:0 0 20px; }
        #photoGallDiv .g-del .g-del-btns{ display:flex; gap:10px; }
        #photoGallDiv .g-del button{ height:54px; border-radius:12px; font-size:16px; font-weight:800; cursor:pointer; -webkit-appearance:none; appearance:none; }
        #photoGallDiv .g-del-no{ flex:1.25; border:1px solid #CCCCCC; background:#fff; color:#121212; }
        #photoGallDiv .g-del-yes{ flex:1; border:none; background:var(--gdanger); color:#fff; }
        </style>

        <!-- 상단 액션바: 수정및재서명(좌 주액션) · 공유/저장/삭제/닫기(우) -->
        <div class="g-bar">
            <span class="g-bartitle" id="g-bartitle">공유</span>
            <a class="order_confirm g-pill" href="/m/diary/done?ordernum=${this.ordernum}">수정 및 재서명</a>
            <span class="g-sp"></span>
            <button type="button" class="g-ic btn-share">${svgShare}<span>공유</span></button>
            <button type="button" class="g-ic btn-download">${svgSave}<span>저장</span></button>
            <button type="button" class="g-ic no_order_confirm btn-delete">${svgTrash}<span>삭제</span></button>
            <button type="button" class="g-ic g-shon btn-close">${svgClose}<span>닫기</span></button>
        </div>

        <!-- 공유/저장 인라인 선택 (문서 모드) -->
        <div class="g-shscrim"></div>
        <div class="g-shacc">
            <div class="g-shrow">
                <button type="button" class="g-shopt pri" data-withphotos="0">확인서만 (기본)</button>
                <button type="button" class="g-shopt sec" data-withphotos="1">작업사진 포함</button>
            </div>
        </div>

        <!-- 탭 -->
        <div class="g-tabs">
            <button type="button" class="gallery-tab on" data-tab="doc">문서 <span class="g-cnt" id="g-cnt-doc">0</span></button>
            <button type="button" class="gallery-tab" data-tab="field">현장 <span class="g-cnt" id="g-cnt-field">0</span></button>
        </div>

        <!-- 썸네일 바 -->
        <div id="doc-box"   class="g-strip" data-tab="doc"></div>
        <div id="field-box" class="g-strip" data-tab="field"></div>

        <!-- 콘텐츠 스테이지 -->
        <div class="photoHolderx1 g-stage b-swipe" data-mode="doc">
            <div class="b-swipe__track"></div>
            <button type="button" class="b-swipe__prev" aria-label="이전">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <button type="button" class="b-swipe__next" aria-label="다음">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
            <span class="g-caption" id="g-caption"></span>
            <div class="gallery-empty">사진 내역이 없습니다</div>
        </div>

        <!-- 시니어 삭제 확인 -->
        <div class="g-del-ov">
            <div class="g-del">
                <h4 id="g-del-title">삭제할까요?</h4>
                <p id="g-del-msg">삭제하면 되돌릴 수 없습니다.</p>
                <div class="g-del-btns">
                    <button type="button" class="g-del-no">취소</button>
                    <button type="button" class="g-del-yes">삭제</button>
                </div>
            </div>
        </div>`;
    }

    /** 사진 목록 불러오기 */
    getPhoto = function() {
        let self = this;
        $.ajax({
            type: "GET",
            url: `/m/ajax/gallery/${self.ordernum}/photos`,
            success: function(data) { self.drawPhotos(data); },
            error: function(err) { console.error("사진 불러오기 실패", err); }
        });
    }

    /**
     * 사진 순서대로 불러오기 (전자작업확인서 <최신> - 문서 - 전자작업확인서 <구> - 현장사진)
     * @param data
     */
    drawPhotos = function(data) {
        let self = this;
        const $docBox = $('#doc-box');
        const $fieldBox = $('#field-box');

        $docBox.empty();
        $fieldBox.empty();
        this.images = [];

        const docs = data.docs || [];
        const photos = data.photos || [];

        // 문서 영역 (전자작업확인서 + 작업문서)
        $.each(docs, function(i, row) {
            $docBox.append(self.createThumb(row.img_url, row.img_id, row.dot));
            self.images.push({
                img_id: row.img_id,
                img_url: row.original_url,
                order_confirm: row.phototype == 0,                 // 최신 전자작업확인서 (수정 및 재서명 대상)
                is_confirm: (row.phototype == 0 || row.phototype == 3), // 전자작업확인서 전체 (삭제 판정)
                odr: parseInt(row.odr) || 0,
                group: 'doc',
            });
        });

        // 작업(현장) 영역
        $.each(photos, function(i, row) {
            $fieldBox.append(self.createThumb(row.img_url, row.img_id));
            self.images.push({
                img_id: row.img_id,
                img_url: row.original_url,
                order_confirm: false,
                group: 'field',
            });
        });

        // 탭 개수 반영
        const docCount = this.images.filter(img => img.group === 'doc').length;
        const fieldCount = this.images.filter(img => img.group === 'field').length;
        $('#g-cnt-doc').text(docCount);
        $('#g-cnt-field').text(fieldCount);

        // 전자작업확인서 차수 집계 (관리자 삭제 / 5차 경고용) — 삭제분 포함 서버값 우선
        const confirms = this.images.filter(img => img.is_confirm);
        this.confirmCount = confirms.length;
        this.odr = parseInt(data.confirm_max_odr)
            || confirms.reduce((max, img) => Math.max(max, img.odr || 0), 0);

        // 이미지 없음 — 안내문구 (삭제 직전 그룹 유지, 없으면 doc)
        if (this.images.length == 0) {
            this.showEmpty(this._preferredGroup || 'doc');
            this._preferredGroup = null;
            return;
        }

        const current = this.images.find(img => img.img_id == this.img_id);
        if (!current) {
            const preferred = this._preferredGroup
                ? this.images.find(img => img.group === this._preferredGroup)
                : null;
            this.img_id = (preferred || this.images[0]).img_id;
        }
        this._preferredGroup = null;
        this.showPhoto(this.img_id);
    }

    /** 현재 탭에 속한 사진 목록 */
    _groupImages = function() {
        return this.images.filter(img => img.group === this.currentGroup);
    }

    /**
     * 빈 상태 — 메인 이미지 숨기고 안내문구 노출.
     * @param group 활성화할 탭 (doc | field)
     */
    showEmpty = function(group) {
        this.destroySwipe();
        $('#photoGallDiv .b-swipe__track').empty().css('transform', 'none');
        $('#photoGallDiv .b-swipe__prev, #photoGallDiv .b-swipe__next').hide();
        $('#photoGallDiv .g-caption').hide();
        $('#photoGallDiv .gallery-empty').css('display', 'flex');
        $('#photoGallDiv .gallery-thumb').removeClass('cur');
        this.updateActionButtons(null);
        this.activateTab(group || 'doc');
    }

    /**
     * 현재 탭의 사진들로 스와이프 트랙을 다시 그리고 공용 모듈에 위임.
     * 사진 목록/탭이 그대로면 아무것도 하지 않는다 (재초기화 방지).
     */
    buildTrack = function() {
        const self = this;
        const list = this._groupImages();
        const key = this.currentGroup + ':' + list.map(img => img.img_id).join(',');
        if (key === this._trackKey) return;

        this.destroySwipe(); // _trackKey 를 비우므로 반드시 키 저장보다 먼저
        this._trackKey = key;

        // 작업(field)은 회색 프레임 <span> 으로 이미지를 감싼다. 문서(doc)는 이미지 직접.
        const wrap = (img) => this.currentGroup === 'field'
            ? `<span><img src="${img.img_url}" class="gallery-card-img"></span>`
            : `<img src="${img.img_url}" class="gallery-card-img">`;
        const cards = list.map(img =>
            `<div class="b-swipe__card gallery-card" data-imgid="${img.img_id}">${wrap(img)}</div>`
        ).join('');

        $('#photoGallDiv .b-swipe__track').css('transform', 'none').html(cards);
        $('#photoGallDiv .gallery-empty').css('display', 'none');
        $('#photoGallDiv .b-swipe__prev, #photoGallDiv .b-swipe__next').show();

        // 카드 1장이면 Swipe.init 이 null → 좌우버튼도 스스로 숨김
        this.swipe = $j.Ui.Swipe.init('#photoGallDiv .g-stage', {
            onChange: function (index) {
                const cur = self._groupImages()[index];
                if (!cur) return;
                self.img_id = cur.img_id;
                self.syncCurrent(cur);
            },
        });
    }

    destroySwipe = function() {
        if (this.swipe) this.swipe.destroy();
        this.swipe = null;
        this._trackKey = null;
    }

    /**
     * 현재 카드에 맞춰 주변 UI 동기화 — 확대 해제 / 액션버튼 / 썸네일 강조 / 카운터·캡션 / 공유대상 id
     * @param img 현재 이미지 메타
     */
    syncCurrent = function(img) {
        const list = this._groupImages();
        const idx = list.findIndex(row => row.img_id == img.img_id);
        const n = list.length;

        // 장 이동 시 확대 자동 해제 (스펙 §6)
        $('#photoGallDiv .g-stage').removeClass('zoomed');

        // 공유·저장이 참조하는 #job_imagshowBigObj 를 현재 카드 이미지로
        $('#photoGallDiv .gallery-card-img').removeAttr('id');
        $(`#photoGallDiv .gallery-card[data-imgid="${img.img_id}"] .gallery-card-img`).attr('id', 'job_imagshowBigObj');

        this.updateActionButtons(img);

        // 썸네일 강조 + 스트립 안으로 스크롤
        $('#photoGallDiv .gallery-thumb').removeClass('cur');
        const $thumb = $(`#photoGallDiv .gallery-thumb[data-imgid="${img.img_id}"]`).addClass('cur');
        if ($thumb.length && $thumb[0].scrollIntoView) {
            $thumb[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        // 하단 캡션 — 숫자만 (문서/현장 공통)
        $('#photoGallDiv .g-caption').text(`${idx + 1} / ${n}`).show();
    }

    /** 화면 탭 = 1.35배 확대 토글 */
    toggleZoom = function() {
        $('#photoGallDiv .g-stage').toggleClass('zoomed');
    }

    /** 탭 전환 — 스테이지 모드·스트립 표시/숨김 + 활성 스타일 */
    activateTab = function(group) {
        if (group !== 'doc' && group !== 'field') group = 'doc';
        this.currentGroup = group;
        this.closeShare();

        $('#photoGallDiv .g-stage').attr('data-mode', group);

        // 썸네일 스트립 — 해당 그룹이 2장 이상일 때만 (스펙 §3)
        const docN = this.images.filter(i => i.group === 'doc').length;
        const fieldN = this.images.filter(i => i.group === 'field').length;
        $('#doc-box').toggleClass('on', group === 'doc' && docN > 1);
        $('#field-box').toggleClass('on', group === 'field' && fieldN > 1);

        $('#photoGallDiv .gallery-tab').each(function () {
            $(this).toggleClass('on', $(this).data('tab') === group);
        });
    }

    /** 썸네일 엘리먼트 생성 */
    createThumb = function(url, imgId, dot=false) {
        const dotClass = dot ? 'notification-dot' : '';
        const $div = $(`<button type="button" class="gallery-thumb ${dotClass}" data-imgid="${imgId}"></button>`)
            .html(`<img src="${url}" alt="">`);
        $div.on('click', () => this.showPhoto(imgId));
        return $div[0];
    }

    /**
     * 큰 화면으로 이미지 보여주기
     * @param imgId
     */
    showPhoto = function(imgId) {
        let self = this;
        const img = this.images.find(img => img.img_id == imgId);
        if (!img || !img.img_url) { self.updateActionButtons(null); return; }

        self.img_id = imgId;
        self.activateTab(img.group || 'doc');
        self.buildTrack();

        const idx = self._groupImages().findIndex(row => row.img_id == imgId);
        if (self.swipe && idx >= 0) self.swipe.to(idx);

        self.syncCurrent(img);
    }

    /**
     * 액션바 좌측(수정 및 재서명) / 삭제 노출 결정
     * - 일반 사진(작업문서/현장사진/정산서류): 누구나 삭제
     * - 전자작업확인서: 삭제는 관리자만
     * - 수정 및 재서명: 지금 보고 있는 사진이 전자작업확인서일 때만 (5차 미만). 작업문서·현장사진에는 안 뜬다.
     * @param img 현재 이미지 메타 (빈 갤러리/빈 탭이면 null)
     */
    updateActionButtons = function (img) {
        const $del  = $('.no_order_confirm');
        const $edit = $('.order_confirm');
        const isAdmin = (typeof G5 !== 'undefined') && !!G5.isAdmin;

        // 전자작업확인서(is_confirm)를 보고 있고, 아직 5차 미만일 때만 노출
        const showEdit = !!(img && img.is_confirm) && this.odr < 5;
        showEdit ? $edit.css('visibility', 'visible') : $edit.css('visibility', 'hidden');

        if (!img) {
            $del.show();
        } else if (img.is_confirm) {
            isAdmin ? $del.show() : $del.hide();
        } else {
            $del.show();
        }
    }

    openEdit = function () {
        location.href = '/m/diary/done?ordernum=' + this.ordernum;
    }

    /**
     * 갤러리 닫기 — 오버레이 열림 중이면 오버레이만 닫음 (스펙 §2·§6)
     */
    onClose = function() {
        if (this.shOpen) { this.closeShare(); return; }
        this.popcloseimg();
    }

    popcloseimg = function(){
        this.destroySwipe();
        var Tar = document.getElementById("photoGallDiv");
        Tar.innerHTML = "";
        Tar.style.display = "none";
        if (Tar && Tar.removeEventListener) Tar.removeEventListener('touchmove', null);
    }

    /** 문서에 실을 현장사진(작업탭)이 있는가 — '작업사진 포함' 선택지 노출 조건 */
    _hasFieldPhotos = function() {
        return this.images.some(img => img.group === 'field');
    }

    /* ── 공유 / 저장 ─────────────────────────────────────
       전자작업확인서: 바 아래 인라인 선택(확인서만 / 작업사진 포함)
       그 외 일반 사진(작업문서·현장사진): 지금 보는 이미지를 즉시 처리 (기존 동작) */
    onAction = function(act) {
        const cur = this.images.find(i => i.img_id == this.img_id);
        if (!(cur && cur.is_confirm)) {              // 일반 사진 = 즉시
            (act === 'save') ? this.downloadit() : this.shareFile();
            return;
        }
        // 현장사진이 없으면 고를 게 '확인서만' 뿐 — 선택지를 띄우지 않고 바로 처리
        if (!this._hasFieldPhotos()) {
            (act === 'save') ? this.downloadit() : this.shareFile();
            return;
        }
        if (this.shOpen && this.shareAct === act) { this.closeShare(); return; } // 같은 버튼 재탭 = 접기
        this.shareAct = act;
        this.shOpen = true;
        $('#g-bartitle').text(act === 'save' ? '저장' : '공유');
        $('#photoGallDiv').addClass('g-sh-open');
        $('#photoGallDiv .g-shacc').addClass('on');
        $('#photoGallDiv .g-shscrim').addClass('on');
    }

    closeShare = function() {
        this.shOpen = false;
        $('#photoGallDiv').removeClass('g-sh-open');
        $('#photoGallDiv .g-shacc').removeClass('on');
        $('#photoGallDiv .g-shscrim').removeClass('on');
    }

    /**
     * 인라인 선택 확정.
     * · 확인서만       = 지금 보고 있는 확인서 이미지를 그대로 공유/저장
     * · 작업사진 포함  = 그 순간 확인서+작업사진 합성 이미지를 생성해 임시 파일로 올린 뒤 그 URL 로 공유/저장
     * @param withPhotos 작업사진 포함 여부
     */
    pickShare = function(withPhotos) {
        const act = this.shareAct;
        this.closeShare();
        if (!withPhotos) {
            (act === 'save') ? this.downloadit() : this.shareFile();
            return;
        }
        this._shareComposite(act);
    }

    /** 캡처 헬퍼(order-confirm-capture.js)를 필요 시 지연 로드 */
    _ensureCapture = function() {
        if (window.OrderConfirmCapture) return Promise.resolve();
        return new Promise((res, rej) => {
            const s = document.createElement('script');
            s.src = '/js/order-confirm-capture.js';
            s.onload = () => res();
            s.onerror = () => rej(new Error('캡처 모듈 로드 실패'));
            document.head.appendChild(s);
        });
    }

    /**
     * 작업사진 포함 합성 이미지 생성 → 임시 업로드 → 그 URL 로 공유/저장.
     * 문서(전자작업확인서 photo 모드)를 html2canvas 로 캡처해 서버에 올린다(임시·고아 파일).
     * @param act 'share' | 'save'
     */
    _shareComposite = function(act) {
        const self = this;
        const cur = this.images.find(i => i.img_id == this.img_id);
        const odr = (cur && cur.odr) || this.odr || 1;

        // 저장된 정본은 사진 없는 버전이므로, 여기서만 mode=photo 로 합성본을 새로 캡처한다.
        // 현장사진 0장이면 이 경로 자체를 타지 않는다 (onAction 에서 선택지를 안 띄움).
        $('#PageMoveLoading').show();
        this._ensureCapture()
            .then(() => OrderConfirmCapture.capture({
                docUrl: `/m/order/${self.ordernum}/confirm-doc?odr=${odr}&mode=photo`,
            }))
            .then(dataUrl => $.ajax({
                type: 'POST',
                url: `/m/ajax/order/${self.ordernum}/confirm-share-image`,
                data: { odr: odr, image: dataUrl },
            }))
            .then(r => {
                $('#PageMoveLoading').hide();
                if (!r || !r.result || !r.url) {
                    Util.swalert((r && r.message) || '이미지 생성에 실패했습니다', 'warning');
                    return;
                }
                if (act === 'save') $j.F.App.downloadImage(r.url);
                else if (!$j.F.App.shareFile(r.url)) alert('앱을 업데이트해주세요');
            })
            .catch(err => {
                $('#PageMoveLoading').hide();
                console.error('작업사진 포함 공유 실패', err);
                Util.swalert('이미지 생성에 실패했습니다', 'warning');
            });
    }

    /** 공유하기 */
    shareFile = function(){
        if (!this.hasCurrentImage()) { Util.swalert("공유할 사진이 없습니다", "warning"); return; }
        var Tar = document.getElementById("job_imagshowBigObj");
        if (Tar) {
            if (!$j.F.App.shareFile(Tar.src)) alert('앱을 업데이트해주세요');
        }
    }

    /** 저장하기 */
    downloadit = function(){
        if (!this.hasCurrentImage()) { Util.swalert("저장할 사진이 없습니다", "warning"); return; }
        var Tar = document.getElementById("job_imagshowBigObj");
        if (Tar) $j.F.App.downloadImage(Tar.src);
    }

    /**
     * 현재 활성 탭에 표시 중인 사진이 있는지 (빈 갤러리 / 빈 탭 가드).
     */
    hasCurrentImage = function(){
        const img = this.images.find(img => img.img_id == this.img_id);
        return !!(img && img.img_url && img.group === this.currentGroup);
    }

    /**
     * 삭제하기 — 전자작업확인서는 관리자 전용/5차 경고, 그 외는 시니어 확인 다이얼로그
     */
    deletePhoto = function() {
        let self = this;
        if (!self.hasCurrentImage()) { Util.swalert("삭제할 사진이 없습니다", "warning"); return; }

        const cur = self.images.find(img => img.img_id == self.img_id);

        if (cur && cur.is_confirm) {
            const isAdmin = (typeof G5 !== 'undefined') && !!G5.isAdmin;
            if (!isAdmin) { Util.swalert("전자작업확인서는 관리자만 삭제할 수 있습니다", "warning"); return; }
            // 5차까지 발행 이력이 있으면(삭제분 포함) 경고 후 진행
            if (self.odr >= 5) {
                Util.swalert(
                    ['전자작업확인서 삭제', 'warning', '이미 전자작업확인서가 5차까지 발행되어 더 이상 재서명할 수 없습니다.\n삭제하시겠습니까?'],
                    function () { self._doDeletePhoto(); },
                    ['삭제', '취소']
                );
                return;
            }
            self.openDelDlg('전자작업확인서를 삭제할까요?', '삭제하면 되돌릴 수 없습니다.\n발행된 확인서가 목록에서 사라져요.');
            return;
        }

        self.openDelDlg('사진을 삭제할까요?', '삭제하면 되돌릴 수 없습니다.');
    }

    /** 시니어 삭제 확인 다이얼로그 열기 */
    openDelDlg = function(title, msg) {
        this.closeShare();
        $('#g-del-title').text(title);
        $('#g-del-msg').html((msg || '삭제하면 되돌릴 수 없습니다.').replace(/\n/g, '<br>'));
        $('#photoGallDiv .g-del-ov').addClass('on');
    }

    closeDelDlg = function() {
        $('#photoGallDiv .g-del-ov').removeClass('on');
    }

    /**
     * 실제 삭제 요청 (확인 절차 통과 후 호출)
     */
    _doDeletePhoto = function() {
        let self = this;
        const deletedImgId = self.img_id;
        let sendData = { 'img_id': deletedImgId };

        // 삭제 후 같은 탭 유지 + 다음/이전 사진 후보
        const current = self.images.find(img => img.img_id == deletedImgId);
        const currentGroup = current?.group || 'doc';
        const sameGroup = self.images.filter(img => img.group === currentGroup);
        const curIdx = sameGroup.findIndex(img => img.img_id == deletedImgId);
        const fallbackImgId = sameGroup.length > 1
            ? (sameGroup[curIdx + 1] || sameGroup[curIdx - 1])?.img_id
            : null;

        $.ajax({
            type: 'DELETE',
            url: `/m/ajax/gallery/${self.ordernum}/photos`,
            data: sendData,
            success: function (data) {
                if (!data.result) { alert(data.message); return; }
                // 삭제 성공 — 외부 모듈(DiaryDocs/DiaryJobs 등) 풀 동기화 알림
                $j.Common.EventBus.trigger('gallery:delete', { ordernum: self.ordernum, img_id: deletedImgId });

                if (fallbackImgId) self.img_id = fallbackImgId;
                self._preferredGroup = currentGroup;
                self.getPhoto();
            }
        });
    }
}